<img src="assets/icons/loading-spinner.svg">
<div class="flex align-items-center justify-content-center">
    <p-button [hidden]="!visible" label="Interrompi" icon="pi pi-times" severity="secondary" (onClick)="close()"></p-button>
</div>